import { ChainId } from '@padiswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x5CCBA81867AE1F9d470a9514fb9B175E84D47979', // TODO
  [ChainId.TESTNET]: '0x70bD20cb4C45faFfA698BF58beE56054D922D92A'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
